import { Link, useLocation } from 'react-router-dom';
import { getEventResult, type EventKol } from 'r/atoms';
import { Button } from '@/components/ui/button';
import { DirectionBadge, EventResultBadge, formatDate } from '../shared';

export default function KolEvents({ kol }: { kol: EventKol }) {
  const location = useLocation();

  return (
    <div className="overflow-x-auto rounded-xl border">
      <table className="w-full text-left text-sm">
        <thead className="bg-muted/50 text-muted-foreground text-xs uppercase">
          <tr>
            <th className="py-3 px-4 font-medium">Created</th>
            <th className="py-3 px-4 font-medium">Title</th>
            <th className="py-3 px-4 font-medium">Symbol</th>
            <th className="py-3 px-4 font-medium">Direction</th>
            <th className="py-3 px-4 font-medium">Status</th>
            <th className="py-3 px-4 font-medium">Result</th>
            <th className="py-3 px-4 font-medium">Ends</th>
            <th className="py-3 px-4 font-medium" />
          </tr>
        </thead>
        <tbody>
          {kol.events.map((event) => (
            <tr
              key={event.id}
              className="border-b hover:bg-muted/50 transition-colors"
            >
              <td className="py-3 px-4 text-muted-foreground whitespace-nowrap">
                {formatDate(event.createdAt)}
              </td>
              <td className="py-3 px-4 max-w-sm">
                <span className="line-clamp-2" title={event.title}>
                  {event.title}
                </span>
              </td>
              <td className="py-3 px-4 font-semibold whitespace-nowrap">
                {event.symbol}
              </td>
              <td className="py-3 px-4">
                <DirectionBadge isUp={event.isDirectionUp} />
              </td>
              <td className="py-3 px-4 text-xs">{event.status ?? '—'}</td>
              <td className="py-3 px-4">
                <EventResultBadge result={getEventResult(event)} />
              </td>
              <td className="py-3 px-4 text-muted-foreground whitespace-nowrap">
                {formatDate(event.endDate)}
              </td>
              <td className="py-3 px-4 text-right">
                <Button variant="outline" size="sm" asChild>
                  <Link
                    to={`/events/${event.id}/edit`}
                    state={{ background: location }}
                  >
                    Open
                  </Link>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
